
import React from "react";
import styles from "./Feedback.module.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { TiStarFullOutline } from "react-icons/ti";
import circleUser from "../assets/account_circle.png";
import CardSlider from "./CardSlider/CardSlider";

export default function Feedback() {
 
  return (
    <div className={styles.feedbackContainer}>
      <div style={{width:"90%",}}>
        <h2 className={styles.heading}>Customer Feedback</h2>
      
        </div>

      <CardSlider/>
    </div>
  );
}
